/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  Select,
  Spinner,
  Stack,
  Table as ChakraTable,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import {
  compareItems,
  RankingInfo,
  rankItem
} from '@tanstack/match-sorter-utils';
import {
  Column,
  ColumnDef,
  FilterFn,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingFn,
  sortingFns,
  Table,
  useReactTable
} from '@tanstack/react-table';
import React, { Dispatch, ReactNode, useState } from 'react';
import { AiOutlineInfoCircle, AiOutlineSearch } from 'react-icons/ai';

import { OrderArrow } from '../../assets/icons/OrderArrow';
import { randomComponentId } from '../../utils/components/randomComponentId';

declare module '@tanstack/table-core' {
  interface FilterFns {
    fuzzy: FilterFn<unknown>;
  }
  interface FilterMeta {
    itemRank: RankingInfo;
  }
  interface SortingFns {
    myCustomSorting: SortingFn<unknown>;
  }
}

const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(row.getValue(columnId), value);

  // Store the itemRank info
  addMeta({
    itemRank
  });

  // Return if the item should be filtered in/out
  return itemRank.passed;
};

const fuzzySort: SortingFn<any> = (rowA, rowB, columnId) => {
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId]?.itemRank!,
      rowB.columnFiltersMeta[columnId]?.itemRank!
    );
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

const RowBreak = () => {
  return (
    <Tr border="none">
      <Th border="none" p=".2rem" />
    </Tr>
  );
};

type ReactTableProps = {
  columns: any;
  data: any;
  isLoading: boolean;
  setOrderBy?: any;
  fnc?: any;
  ExpandedComponent?: any;
};

export const ReactTable = ({
  columns,
  data,
  isLoading,
  setOrderBy,
  fnc,
  ExpandedComponent
}: ReactTableProps) => {
  const [expanded, setExpanded] = useState<any>({});

  const table = useReactTable({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter
    },
    state: {
      expanded
    },
    sortingFns: {
      myCustomSorting: (rowA: any, rowB: any, columnId: any) => {
        return rowA.getValue(columnId).value < rowB.getValue(columnId).value
          ? 1
          : -1;
      }
    },
    onExpandedChange: setExpanded,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    debugTable: true
  });

  return (
    <>
      <TableContainer>
        <ChakraTable
          color="#001E64"
          sx={{
            borderCollapse: 'separate',
            borderSpacing: '0 0'
          }}
        >
          <Thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  return (
                    <Th
                      border="0"
                      key={header.id}
                      colSpan={header.colSpan}
                      h="2rem"
                      pl="1.5rem"
                      fontSize=".9rem"
                      textTransform="none"
                      color="#001E64"
                      onClick={() => {
                        setOrderBy(header.column.id);
                        fnc({
                          orderBy: header.column.id,
                          orderDirection: !header.column.getIsSorted()
                            ? 'asc'
                            : header.column.getIsSorted() === 'asc'
                            ? 'desc'
                            : ''
                        });
                      }}
                    >
                      <>
                        <Flex
                          title="Ordenar"
                          gap=".5rem"
                          cursor={header.column.getCanSort() ? 'pointer' : ''}
                          userSelect={
                            header.column.getCanSort() ? 'none' : 'auto'
                          }
                          {...{
                            onClick: header.column.getToggleSortingHandler()
                          }}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{
                            asc: (
                              <Flex>
                                <OrderArrow
                                  color={
                                    header.column.getIsSorted()
                                      ? '#001E64'
                                      : '#AAAAAA'
                                  }
                                />
                                <OrderArrow
                                  transform="rotate(180deg)"
                                  mt="2px"
                                  color={
                                    header.column.getIsSorted()
                                      ? '#AAAAAA'
                                      : '#001E64'
                                  }
                                />
                              </Flex>
                            ),
                            desc: (
                              <Flex>
                                <OrderArrow
                                  color={
                                    header.column.getIsSorted()
                                      ? '#AAAAAA'
                                      : '#001E64'
                                  }
                                />
                                <OrderArrow
                                  transform="rotate(180deg)"
                                  mt="2px"
                                  color={
                                    header.column.getIsSorted()
                                      ? '#001E64'
                                      : '#AAAAAA'
                                  }
                                />
                              </Flex>
                            )
                          }[header.column.getIsSorted() as string] ??
                            (header.column.getCanSort() && (
                              <Flex>
                                <OrderArrow color="#AAAAAA" />
                                <OrderArrow
                                  transform="rotate(180deg)"
                                  mt="2px"
                                  color="#AAAAAA"
                                />
                              </Flex>
                            ))}
                        </Flex>
                      </>
                    </Th>
                  );
                })}
              </Tr>
            ))}
          </Thead>
          {!isLoading ? (
            <Tbody>
              {table.getRowModel().rows.map((row) => {
                return (
                  <>
                    <Tr
                      key={row.id}
                      h="3.5rem"
                      bg="#F4F4F4"
                      sx={{
                        '&:nth-of-type(6n+4)': { backgroundColor: '#D3DEED' }
                      }}
                    >
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <Td
                            key={cell.id}
                            _first={{
                              borderLeft: '5px solid #FF5000',
                              borderLeftRadius: '5px'
                            }}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </Td>
                        );
                      })}
                    </Tr>
                    <Tr
                      key={randomComponentId()}
                      display={row.getIsExpanded() ? 'normal' : 'none'}
                      border="10px solid black !important"
                      bg="#F4F4F4"
                      sx={{
                        '&:nth-of-type(6n+5)': { backgroundColor: '#D3DEED' }
                      }}
                    >
                      <Td
                        colSpan={100}
                        _first={{
                          borderLeft: '5px solid #FF5000',
                          borderLeftRadius: '5px'
                        }}
                      >
                        <Flex>
                          <ExpandedComponent row={row} />
                        </Flex>
                      </Td>
                    </Tr>
                    <RowBreak key={randomComponentId()} />
                  </>
                );
              })}
            </Tbody>
          ) : (
            <Tbody>
              <Tr>
                <Td
                  colSpan={+table.getHeaderGroups()[0].headers.length}
                  textAlign="center"
                  h="41.5rem"
                  // display="flex"
                  // justify="center"
                  // align="center"
                >
                  <Spinner />
                </Td>
              </Tr>
            </Tbody>
          )}
        </ChakraTable>
      </TableContainer>
    </>
  );
};
